import CloseSvg from '@/icons/close.svg?react'
import { blockPage, unblockPage } from '@/utils/page'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { createPortal, useEffect, useRef } from 'preact/compat'
import styles from './index.module.scss'

export const Popup:
  & FunctionalComponent<{
    width?: number
    class?: string
    onClose?: () => void
  }>
  & {
    Title: FunctionalComponent
    Footer: FunctionalComponent
    Buttons: FunctionalComponent<{
      class?: string
    }>
    Fields: FunctionalComponent
    Field: FunctionalComponent<{
      label?: string
    }>
    Info: FunctionalComponent
    Msg: FunctionalComponent
  } = props => {
    const mouseDownTarget = useRef<EventTarget | null>(null)
    const rootRef = useRef(null)

    useEffect(() => {
      blockPage()

      const escHandler = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          props.onClose?.()
        }
      }

      document.addEventListener('keydown', escHandler)

      return () => {
        unblockPage()
        document.removeEventListener('keydown', escHandler)
      }
    }, [])

    return createPortal(
      <div
        ref={rootRef}
        class={classNames(styles.root, props.class)}
        onMouseDown={e => {
          mouseDownTarget.current = e.target
        }}
        onClick={e => {
          if (e.target === rootRef.current && mouseDownTarget.current === rootRef.current) {
            props.onClose?.()
          }
        }}
      >
        <div
          class={styles.inner}
          style={{
            maxWidth: props.width,
          }}
        >
          <div class={styles.popup}>
            <button
              class={styles.close}
              onClick={props.onClose}
            >
              <CloseSvg />
            </button>
            {props.children}
          </div>
        </div>
      </div>,
      document.body,
    )
  }

Popup.Title = props => (
  <div class={styles.title}>
    {props.children}
  </div>
)

Popup.Footer = props => (
  <div class={styles.footer}>
    {props.children}
  </div>
)

Popup.Buttons = props => (
  <div class={classNames(styles.buttons, props.class)}>
    {props.children}
  </div>
)

Popup.Fields = props => (
  <div class={styles.fields}>
    {props.children}
  </div>
)

Popup.Field = props => (
  <div class={styles.field}>
    <div class={styles.label}>
      {props.label}
    </div>

    {props.children}
  </div>
)

Popup.Info = props => (
  <div class={styles.info}>
    {props.children}
  </div>
)

Popup.Msg = props => (
  <div class={styles.msg}>
    {props.children}
  </div>
)
